
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automated-insights",
      function () {
        return require("private-next-pages/automated-insights.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automated-insights"])
      });
    }
  